<template>
    <div class="promotionList" :style="'padding: 0 10px;margin-top: ' + item.mbConfig.val + 'px;'">
        <div class="promotionListBox">
            <div class="titile-list" v-if="0">
                <div class="title-item">
                    <span>精选商品</span>
                    <div class="tag">
                        <span>精选好物</span>
                    </div>
                </div>
            </div>
            <div class="title-box" v-else>
                <div class="left"></div>
                <span>{{ item.tabConfig.list[item.tabConfig.type].name }}</span>
                <div class="right"></div>
            </div>

            <div class="product-list">
                <div class="product-item" v-for="(i,index) in 4" :key="index">
                    <img src="@/components/decoration/static/not_img_product.png">
                    <div class="product-detail">
                        <span v-if="item.titleShow.val">小米智能保温杯，使用最好的材质打造</span>
                        <div class="original-price" v-if="item.opriceShow.val">
                            <span>￥</span>
                            <span class="price">125.00</span>
                        </div>
                        <div class="product-price" :style="'color:' + item.fontColor.color[0].item" v-if="item.priceShow.val">
                            <span>￥</span>
                            <span class="price">119.00</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bottom-line-box">
                <span>我是有底线的~</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        item:{
            type:Object,
            default: {}
        }
    },
    data(){
        return{}
    }
}
</script>
<style scoped lang="scss">
.promotionListBox{
    width: 100%;

    .titile-list{
        width: 100%;
        height: 65px;
        display: flex;
        align-items: center;

        .title-item{
            width: 25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-size: 14px;
            .tag{
                font-size: 12px;
            }
        }
    }

    .title-box{
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .left{
            width: 70px;
            height: 1px;
            background-color: #c0c0c0;
        }

        .right{
            width: 70px;
            height: 1px;
            background-color: #c0c0c0;
        }
    }

    .product-list{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .product-item{
            width: 158px;
            margin-top: 15px;
            background-color: #fff;
            border-radius: 8px;
            font-size: 14px;

            span{
                line-height: 30px;
                text-align: center;
            }

            img{
                width: 158px;
                height: 158px;
            }

            .product-detail{
                padding: 0 10px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                .original-price{
                    font-size: 12px;
                    color: #aaaaaa;

                    span{
                        line-height: 12px;
                    }

                    .price{
                        text-decoration: line-through;
                    }
                }

                .product-price{
                    font-size: 12px;
                    font-weight: 700;
                    color: #fd502f;

                    span{
                        line-height: 25px;
                    }

                    .price{
                        font-size: 14px;
                    }
                }
            }


        }

        //:nth-child(1),:nth-child(2){
        //    margin-top: 0;
        //}
    }

    .bottom-line-box{
        width: 100%;
        height: 30px;
        font-size: 12px;
        color: #666;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>